import { render, staticRenderFns } from "./editDriverPrice.vue?vue&type=template&id=44f0b02e&scoped=true&"
import script from "./editDriverPrice.vue?vue&type=script&lang=js&"
export * from "./editDriverPrice.vue?vue&type=script&lang=js&"
import style0 from "./editDriverPrice.vue?vue&type=style&index=0&id=44f0b02e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44f0b02e",
  null
  
)

export default component.exports